import React from 'react'
import { DisplayNewProsuctLayout } from './DisplayNewProsuctLayout'
import SectionHeading from '../../SectionHeading'
import Spacing from '../../Spacing'

export const NewProductsLayout = ({ data, subsectionpara, subsectiontitle, sectionTitle }) => {
    return (
        <div className="container">
            <SectionHeading title={sectionTitle} center />
            <Spacing md="20" lg="20" />
            <h3 class="cs_section_subtitle text-uppercase cs_accent_color cs_semibold m-0 cs_accent_color cs_fs_32 text-center">
                {subsectiontitle}
            </h3>
            <Spacing md="20" lg="20" />
            <p className='text-center'>{subsectionpara}</p>
            <div className="cs_departments  ">
                <div
                    className="cs_departments_bg cs_radius_25"

                />

               
                <div className="cs_department_list">
                    <DisplayNewProsuctLayout data={data} />
                </div>
            </div>
        </div>
    )
}
